import { render, staticRenderFns } from "./DeleteRoomLog.vue?vue&type=template&id=abd437e6&lang=pug&"
import script from "./DeleteRoomLog.vue?vue&type=script&lang=ts&"
export * from "./DeleteRoomLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports